import * as React from "react"
import { Link } from "gatsby"
import { getJpTitle, getPagesName, PAGE_IDS } from "src/utils/exportFunctions"
import goTopImg from 'src/images/go_top.svg'
import { getPrivacyPdf } from "src/utils/exportFunctions"

const Footer = () => (
    <footer className="
        bg-footer text-footer text-center pt-8 pb-7
        md:pt-9 md:pb-10 relative
    ">
        <ul className="
            flex flex-col text-11px font-normal tracking-49em pb-8
            md:flex-row md:justify-center md:text-12px
        ">
            <li className="
                pb-8
                md:pb-0 md:px-4 md:leading-tight md:border-r md:border-footer
            ">
                <Link to='/' className="pl-49em">{getJpTitle(PAGE_IDS['top'])}</Link>
            </li>
            <li className="
                pb-8
                md:pb-0 md:px-4 md:leading-tight md:border-r md:border-footer
            ">
                <Link to={'/' + getPagesName(PAGE_IDS['services'])} className="pl-49em">{getJpTitle(PAGE_IDS['services'])}</Link>
            </li>
            <li className="
                pb-8
                md:pb-0 md:px-4 md:leading-tight md:border-r md:border-footer
            ">
                <Link to={'/' + getPagesName(PAGE_IDS['company'])} className="pl-49em">{getJpTitle(PAGE_IDS['company'])}</Link>
            </li>
            <li className="
                pb-8
                md:pb-0 md:px-4 md:leading-tight md:border-r md:border-footer
            ">
                <Link to={'/' + getPagesName(PAGE_IDS['access'])} className="pl-49em">{getJpTitle(PAGE_IDS['access'])}</Link>
            </li>
            <li className="
                pb-8
                md:pb-0 md:px-4 md:leading-tight
            ">
                <a href={getPrivacyPdf()} className="pl-49em" target="_blank" rel="noreferrer">{getJpTitle(PAGE_IDS['privacy'])}</a>
            </li>
        </ul>
        <p className="
            transform scale-75 mt-3
            md:scale-100 md:mt-1
        ">
            <small className="text-10px font-medium tracking-09em">Copyright (c) LION KIKAKU CO., LTD. all rights reserved.</small>
        </p>
        <Link to='#outer-container' className="
            absolute top-10 right-8 w-13px transform -translate-y-1/2
            md:top-1/2 md:right-20 md:w-12
        ">
            <img src={goTopImg} alt="GoTop" />
        </Link>
    </footer>
)

export default Footer
